<template>
    <div>
        <v-row>
            <v-col md="5" cols="12">
                <v-card>
                <v-card-title>{{ $t('Strength') }}</v-card-title>
                <v-card-text>
                    {{ project.swot.strength || '---' }}
                </v-card-text>
                </v-card>
            </v-col>
            <v-col md="5" offset-md="2" cols="12">
                 <v-card>
                <v-card-title>{{ $t('Weakness') }}</v-card-title>
                <v-card-text>
                    {{ project.swot.weakness || '---' }}
                </v-card-text>
                </v-card>
            </v-col>
            </v-row>
            <v-row>
            <v-col md="5" cols="12">
                 <v-card>
                <v-card-title>{{ $t('Opportunities') }}</v-card-title>
                <v-card-text>
                    {{ project.swot.opportunities || '---' }}
                </v-card-text>
                </v-card>
            </v-col>
            <v-col md="5" offset-md="2" cols="12">
                <v-card>
                <v-card-title>{{ $t('Threats') }}</v-card-title>
                <v-card-text>
                    {{ project.swot.threats || '---' }}
                </v-card-text>
                </v-card>
            </v-col>
            </v-row>
    </div>
</template>

<script>
export default {
  name: 'ShowSwot',
  props: [
    'project'
  ]
}
</script>
